import React, { FormEvent, useEffect, useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import api from "../../api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { LINEHAUL_CONSTANTS } from "../../constants/constants"
import { RootState } from "../../store"
import { loadAllPallets } from "../../store/linehaul.store"
import LineHaulTable from "./LineHaulTable"

const MAWBModel = ({
    show,
    setShow,
    warehouse,
    setSelectedRows,
    selectedRows,
    options,
    setOptions,
    data,
    setData,
    submitUpdateCreateMAWB,
    showMessage
}: {
    show: string
    setShow: Function
    warehouse: number
    setSelectedRows: Function
    selectedRows: number[]
    options: Record<string, any>
    setOptions: Function
    data: Record<string, any>
    setData: Function
    submitUpdateCreateMAWB: Function
    showMessage: Function
}) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    //const [isDisabled, setIsDisabled] = useState(false)
    const { allPallets, country, allPalletsloading } = useAppSelector((state: RootState) => state.linehaul)
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const [loading, setLoading] = useState(false)
    const [messageTextAreaLength, setMessageTextAreaLength] = useState(500 - data.comments?.length || 500)
    const [errors, setErrors] = useState([] as string[])
    const [lhPallets, setLHPallets] = useState([] as Record<string, any>[])
    const [mawbPallets, setMAWBPallets] = useState([] as number[])
    const [mawbDetails, setMAWBDetails] = useState({} as Record<string, any>)
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [destination, setDestination] = useState(country)
    const [mawbPrefix, setMawbPrefix] = useState(country === "SA" ? "065" : "607")
    const [reload, setReload] = useState(false)
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)

    const getTomorrowDate = (startDate?: string) => {
        let minDate = startDate ? new Date(Date.parse(startDate)) : new Date()
        let daysToAdd = startDate ? 0 : 1
        minDate.setDate(minDate.getDate() + daysToAdd)
        minDate = new Date(minDate)
        return minDate?.toISOString().split("T")[0]
    }

    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.is_default
    )?.warehouse_id

    const handleClose = () => {
        setMAWBDetails({
            mawb: mawbPrefix
        })
        setMAWBPallets([])
        setLHPallets([])
        setData({})
        setShow("")
        setErrors([])
        setDestination(country)
        setReload(!reload)
    }

    let fields = [
        {
            name: "mawb",
            title: "MAWB",
            required: true,
            colSpan: 4,
            minLength: 11,
            maxLength: 11
        },
        {
            name: "flight_number",
            title: "Flight Number",
            required: true,
            colSpan: 4
        },
        {
            name: "pro_number",
            title: "PRO Number",
            required: false,
            colSpan: 4
        },
        // {
        //     name: "flight_date",
        //     required: true,
        //     title: "Flight Date",
        //     colSpan: 4,
        //     min: getTomorrowDate()
        // },

        {
            name: "export_agent",
            title: "Export Agent",
            required: true,
            colSpan: 3,
            listOfOptions: LINEHAUL_CONSTANTS.EXPORT_AGENTS
        },
        {
            name: "import_agent",
            title: "Import Agent",
            required: true,
            colSpan: 3,
            listOfOptions: LINEHAUL_CONSTANTS.IMPORT_AGENTS
        },
        {
            name: "carrier",
            required: true,
            title: "Carrier",
            colSpan: 3,
            listOfOptions: LINEHAUL_CONSTANTS.CARRIERS
        },
        {
            name: "tracking_company",
            title: "Tracking Company",
            required: true,
            colSpan: 3,
            listOfOptions: LINEHAUL_CONSTANTS.TRACKING_COMPANIES
        },

        {
            name: "gross_weight",
            required: true,
            title: "Gross_Wegiht",
            min: 0,
            colSpan: 4,
            type: "number"
        },
        {
            name: "chargeable_weight",
            title: "Ch_Wegiht",
            required: true,
            min: 0,
            colSpan: 4,
            type: "number"
        },
        {
            name: "no_of_packages",
            title: "No. of Packages",
            required: true,
            min: 0,
            colSpan: 4,
            type: "number"
        },

        {
            name: "origin",
            required: true,
            title: "Origin",
            colSpan: 3,
            listOfOptions: LINEHAUL_CONSTANTS.ORIGINS
        },
        {
            name: "etd",
            colSpan: 3,
            title: "ETD",
            type: "date",
            required: true,
            min: getTomorrowDate()
        },
        {
            name: "destination",
            required: true,
            title: "Destination",
            colSpan: 3,
            listOfOptions: LINEHAUL_CONSTANTS.DESTINATIONS
        },
        {
            name: "eta",
            colSpan: 3,
            title: "eta",
            type: "date",
            required: true,
            min: getTomorrowDate()
        },

        { name: "comments", colSpan: 12, title: "Comments", as: "textarea" }
    ]

    const handelInputChanges = (e: FormEvent<HTMLInputElement>, required = false) => {
        let value = e?.currentTarget.value
        let name = e?.currentTarget.name
        if (required && (!value || value?.length === 0 || parseFloat(value) === 0)) {
            setErrors([...errors?.filter((e) => e !== name), name])
        } else {
            setErrors([...errors?.filter((e) => e !== name)])
        }
        let extra = {} as Record<string, any>
        switch (name) {
            case "comments":
                // @ts-ignore
                value = value?.replaceAll(" ", ",").replaceAll("\n", ",")
                let textAreaValue = value
                setMessageTextAreaLength(500 - textAreaValue?.length)
                break
            case "mawb":
                // @ts-ignore
                value = value?.replaceAll(/\D/g, "")
                break
            case "carrier":
                if (value === "SV (Saudi)") {
                    extra["import_agent"] = "Thabit"
                    extra["destination"] = "RUH"
                    extra["mawb"] = "065"
                    setDestination("SA")
                    setReload(!reload)
                } else {
                    extra["import_agent"] = "Linex"
                    extra["destination"] = "AUH/DXB"
                    extra["mawb"] = "607"
                    setDestination("AE")
                    setReload(!reload)
                }
                break
            case "import_agent":
                if (value === "Thabit") {
                    extra["carrier"] = "SV (Saudi)"
                    extra["destination"] = "RUH"
                    extra["mawb"] = "065"
                    setDestination("SA")
                    setReload(!reload)
                } else {
                    extra["carrier"] = "EY (Ettihad)"
                    extra["destination"] = "AUH/DXB"
                    extra["mawb"] = "607"
                    setDestination("AE")
                    setReload(!reload)
                }
                break
            case "destination":
                if (value === "RUH") {
                    extra["carrier"] = "SV (Saudi)"
                    extra["import_agent"] = "Thabit"
                    extra["mawb"] = "065"
                    setDestination("SA")
                    setReload(!reload)
                } else {
                    extra["carrier"] = "EY (Ettihad)"
                    extra["import_agent"] = "Linex"
                    extra["mawb"] = "607"
                    setDestination("AE")
                    setReload(!reload)
                }
                break
            default:
                extra = {}
                break
        }

        setMAWBDetails({ ...mawbDetails, [name]: value, ...extra })
    }

    const checkRequiredFields = (data: Record<string, any>) => {
        let safe = true
        let fieldsWithIssues = [] as string[]
        fields.forEach((f) => {
            if (
                (f.required &&
                    (!data[`${f.name}`] ||
                        data[`${f.name}`]?.length === 0 ||
                        parseFloat(data[`${f.name}`]) === 0)) ||
                (f.name === "mawb" && data[`${f.name}`]?.length < 11)
            ) {
                safe = false
                fieldsWithIssues.push(f.name)
            }
        })
        return {
            status: safe,
            issues: fieldsWithIssues
        }
    }

    const handleSubmit = async () => {
        let validity = checkRequiredFields({
            ...mawbDetails
        })
        setLoading(true)
        if (validity.status) {
            setSubmitting(true)
            await submitUpdateCreateMAWB({
                ...mawbDetails,
                pallets: [...mawbPallets],
                flight_date: mawbDetails.etd,
                country: destination
            })
            setSubmitting(false)
            handleClose()
        } else {
            setErrors([
                ...errors?.filter((e) => !(validity.issues || [])?.includes(e)),
                ...(validity?.issues || [])
            ])
        }
        setLoading(false)
    }

    useEffect(() => {
        setDestination(country)
    }, [country])

    useEffect(() => {
        setMAWBPallets([])
        dispatch(
            loadAllPallets({
                warehouse: selectedWarehouse?.toString() || defaultWarehouse?.toString(),
                destination: destination,
                keyword: options?.keyword?.pallets
            })
        )
    }, [reload, destination])

    useEffect(() => {
        const handleAsyncLogic = async () => {
            if (data.mawb && show === "updateMAWB") {
                setLoading(true)
                try {
                    const response = await api.linehaul.MAWBDetails({
                        mawb: data.mawb
                    })
                    if (!response?.data?.status || !response.data.payload)
                        throw new Error(response?.data?.message ?? "Unable to get mawb data")
                    const { LHPallets: selectedPallets } = response?.data?.payload
                    setMAWBPallets((selectedPallets ?? []).map((pallet: any) => pallet.pallet_id))
                    setLHPallets(
                        (selectedPallets ?? []).concat(
                            allPallets?.pallets?.filter(
                                (p: Record<string, any>) => p?.LHBags?.length > 0 && !p?.lh_mawb_id
                            ) ?? []
                        )
                    )
                    delete response?.data?.payload["LHPallets"]
                    setMAWBDetails({ ...(response?.data?.payload || {}) })
                    setLoading(false)
                } catch (e: any) {
                    setLoading(false)
                    console.log(e)
                    showMessage(e.message ?? "Unable to get pallet data", "danger", "Error")
                }
            } else {
                setLHPallets([
                    ...(allPallets?.pallets?.filter(
                        (p: Record<string, any>) => p?.LHBags?.length > 0 && !p?.lh_mawb_id
                    ) ?? [])
                ])
                setMAWBDetails({
                    ...mawbDetails,
                    mawb: destination === "SA" ? "065" : "607",
                    carrier: destination === "SA" ? "SV (Saudi)" : "EY (Ettihad)",
                    import_agent: destination === "SA" ? "Thabit" : "Linex",
                    destination: destination === "SA" ? "RUH" : "AUH/DXB"
                })
            }
        }
        handleAsyncLogic()
    }, [JSON.stringify(data), destination, JSON.stringify(allPallets?.pallets), reload])

    useEffect(() => {
        setMawbPrefix(destination === "SA" ? "065" : "607")
    }, [destination])

    return (
        <Modal
            size="xl"
            show={["createMAWB", "updateMAWB"].includes(show)}
            onHide={handleClose}
            onClose={handleClose}
            backdrop="static"
            // contentClassName={"gray-bg"}
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title className="text-uppercase mx-2">
                    {mawbDetails?.id ? (
                        <>
                            {t("MASTER AWB")}&nbsp;{`# ${mawbDetails.mawb}`}
                        </>
                    ) : (
                        t("Create MAWB")
                    )}
                </Modal.Title>
            </Modal.Header>
            {(loading || allPalletsloading) && show === "updateMAWB" ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only"></span>
                    </div>
                </div>
            ) : (
                <Modal.Body className="modal-gray-bg">
                    <div className="main-container">
                        <Row>
                            <Col>
                                <strong className="my-2 px-1">{t("Select Pallets")}</strong>
                                <LineHaulTable
                                    data={lhPallets}
                                    setSelectedRows={setMAWBPallets}
                                    selectedRows={mawbPallets}
                                    setShow={setShow}
                                    tableName={"Pallets"}
                                    options={options}
                                    setOptions={setOptions}
                                    createMAWBModel={true}
                                    setReload={setReload}
                                    reload={reload}
                                />
                                <hr />
                                <strong className="px-1">{t("MAWB Details")}</strong>
                                <Form className="font-13 my-3">
                                    <Row className="px-1 justify-content-center align-items-start my-2">
                                        <Col
                                            lg={4}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="mawb" className="required">
                                                    {t("MAWB")}
                                                </Form.Label>
                                                <Form.Control
                                                    value={mawbDetails?.mawb}
                                                    type={"text"}
                                                    minLength={11}
                                                    maxLength={11}
                                                    name={"mawb"}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    placeholder="enter MAWB ..."
                                                    isInvalid={!!errors?.includes("mawb")}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {t(
                                                        `This field is required, must be a valid MAWB and 11 chars long`
                                                    )}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={4}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="flight_number" className="required">
                                                    {t("Flight Number")}
                                                </Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.flight_number}
                                                    type={"text"}
                                                    name={"flight_number"}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    placeholder="enter flight number ..."
                                                    isInvalid={!!errors?.includes("flight_number")}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={4}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="pro_number">{t("PRO Number")}</Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.pro_number}
                                                    type={"text"}
                                                    name={"pro_number"}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    placeholder="enter PRO number ..."
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={4}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start d-none">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="flight_date" className="required">
                                                    {t("Flight Date")}
                                                </Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.flight_date}
                                                    type={"date"}
                                                    min={getTomorrowDate()}
                                                    max={
                                                        mawbDetails?.eta
                                                            ? getTomorrowDate(mawbDetails?.eta)
                                                            : undefined
                                                    }
                                                    name={"flight_date"}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("flight_date")}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="px-1 justify-content-center align-items-start my-2">
                                        <Col
                                            lg={3}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="export_agent" className="required">
                                                    {t("Export Agent")}
                                                </Form.Label>
                                                <Form.Select
                                                    value={mawbDetails.export_agent}
                                                    className="text-capitalize font-13"
                                                    name={"export_agent"}
                                                    placeholder={t("Select export agent...")}
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("export_agent")}>
                                                    <option placeholder="Select export agent">
                                                        Select export agent
                                                    </option>
                                                    {LINEHAUL_CONSTANTS.EXPORT_AGENTS.map((e: string) => (
                                                        <option value={e} key={e}>
                                                            {e}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={3}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="import_agent" className="required">
                                                    {t("Import Agent")}
                                                </Form.Label>
                                                <Form.Select
                                                    value={mawbDetails.import_agent}
                                                    className="text-capitalize font-13"
                                                    name={"import_agent"}
                                                    placeholder={t("Select import agent...")}
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("import_agent")}
                                                    disabled={mawbDetails?.id}>
                                                    <option placeholder="Select import agent">
                                                        Select import agent
                                                    </option>
                                                    {LINEHAUL_CONSTANTS.IMPORT_AGENTS.map((e: string) => (
                                                        <option value={e} key={e}>
                                                            {e}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={3}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="export_agent" className="required">
                                                    {t("Tracking company")}
                                                </Form.Label>
                                                <Form.Select
                                                    value={mawbDetails.tracking_company}
                                                    className="text-capitalize font-13"
                                                    name={"tracking_company"}
                                                    placeholder={t("Select tracking company...")}
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("tracking_company")}>
                                                    <option placeholder="Select tracking company">
                                                        Select tracking company
                                                    </option>
                                                    {LINEHAUL_CONSTANTS.TRACKING_COMPANIES.map((e: string) => (
                                                        <option value={e} key={e}>
                                                            {e}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={3}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="carrier" className="required">
                                                    {t("Carrier")}
                                                </Form.Label>
                                                <Form.Select
                                                    value={mawbDetails.carrier}
                                                    className="text-capitalize font-13"
                                                    name={"carrier"}
                                                    placeholder={t("Select carrier...")}
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("carrier")}
                                                    disabled={mawbDetails?.id}>
                                                    <option placeholder="Select carrier">Select carrier</option>
                                                    {LINEHAUL_CONSTANTS.CARRIERS.map((e: string) => (
                                                        <option value={e} key={e}>
                                                            {e}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="px-1 justify-content-center align-items-start my-2">
                                        <Col
                                            lg={3}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="origin" className="required">
                                                    {t("Origin")}
                                                </Form.Label>
                                                <Form.Select
                                                    value={mawbDetails.origin}
                                                    className="text-capitalize font-13"
                                                    name={"origin"}
                                                    placeholder={t("Select origin...")}
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("origin")}>
                                                    <option placeholder="Select origin">Select origin</option>
                                                    {LINEHAUL_CONSTANTS.ORIGINS.map((e: string) => (
                                                        <option value={e} key={e}>
                                                            {e}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={3}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="destination" className="required">
                                                    {t("Destination")}
                                                </Form.Label>
                                                <Form.Select
                                                    value={mawbDetails.destination}
                                                    className="text-capitalize font-13"
                                                    name={"destination"}
                                                    placeholder={t("Select destination...")}
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("destination")}
                                                    disabled={mawbDetails?.id}>
                                                    <option placeholder="Select destination">
                                                        Select destination
                                                    </option>
                                                    {LINEHAUL_CONSTANTS.DESTINATIONS.map((e: string) => (
                                                        <option value={e} key={e}>
                                                            {e}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={3}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="etd" className="required">
                                                    {t("Flight ETD")}
                                                </Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.etd}
                                                    type={"date"}
                                                    name={"etd"}
                                                    min={getTomorrowDate()}
                                                    max={
                                                        mawbDetails?.eta
                                                            ? getTomorrowDate(mawbDetails?.eta)
                                                            : undefined
                                                    }
                                                    isInvalid={!!errors?.includes("etd")}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e)}
                                                />
                                            </Form.Group>
                                            <Form.Control.Feedback type="invalid">
                                                {t(`This field is required`)}
                                            </Form.Control.Feedback>
                                        </Col>
                                        <Col
                                            lg={3}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="eta" className="required">
                                                    {t("Flight ETA")}
                                                </Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.eta}
                                                    defaultValue={mawbDetails.eta}
                                                    type={"date"}
                                                    name={"eta"}
                                                    min={
                                                        mawbDetails?.etd
                                                            ? getTomorrowDate(mawbDetails.etd)
                                                            : getTomorrowDate()
                                                    }
                                                    isInvalid={!!errors?.includes("eta")}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e)}
                                                />
                                            </Form.Group>
                                            <Form.Control.Feedback type="invalid">
                                                {t(`This field is required`)}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Row>
                                    <Row className="px-1 justify-content-center align-items-start my-2">
                                        <Col
                                            lg={4}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="gross_weight" className="required">
                                                    {t("Gross_Weight")}
                                                </Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.gross_weight}
                                                    min={0}
                                                    type={"number"}
                                                    name={"gross_weight"}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("gross_weight")}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required, and must be more than 0`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={4}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="chargeable_weight" className="required">
                                                    {t("Ch_Weight")}
                                                </Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.chargeable_weight}
                                                    type={"number"}
                                                    name={"chargeable_weight"}
                                                    min={0}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("chargeable_weight")}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required, and must be more than 0`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col
                                            lg={4}
                                            sm={12}
                                            className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="no_of_packages" className="required">
                                                    {t("No. of Packages")}
                                                </Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.no_of_packages}
                                                    type={"number"}
                                                    name={"no_of_packages"}
                                                    min={0}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e, true)}
                                                    isInvalid={!!errors?.includes("no_of_packages")}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {t(`This field is required, and must be more than 0`)}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="px-1 justify-content-center align-items-start my-2">
                                        <Col className="d-flex justify-content-start align-items-start">
                                            <Form.Group className="mb-3 w-100">
                                                <Form.Label htmlFor="comments">{t("Comments")}</Form.Label>
                                                <Form.Control
                                                    value={mawbDetails.comments}
                                                    maxLength={500}
                                                    as="textarea"
                                                    name={"comments"}
                                                    autoComplete="off"
                                                    onChange={(e: any) => handelInputChanges(e)}
                                                    placeholder="Comments..."
                                                />
                                                <div className="float-end">
                                                    <p
                                                        className={`mt-2 ${
                                                            messageTextAreaLength <= 0 && "text-danger"
                                                        }`}>
                                                        {messageTextAreaLength} {t("Chars left")}
                                                    </p>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                        <Row className="px-1">
                            <Col className="d-flex align-items-center justify-content-end">
                                <Button
                                    disabled={loading || submitting}
                                    className="float-end mb-2 gray-bg px-3 mx2"
                                    onClick={handleClose}>
                                    {t("Cancel")}
                                </Button>
                                <Button className="float-end mb-2 primary-bg px-3 mx-2" onClick={handleSubmit}>
                                    {loading ? <div className="spinner-border text-light"></div> : t("Save")}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            )}
        </Modal>
    )
}

export default MAWBModel
